// eslint-disable-next-line @typescript-eslint/no-var-requires
const config = require('../../config.json')

module.exports = function makePath(path) {
  return config.basePath + path
}
